<template>
    <div id="vMenu">
        <div class="list-group list-group-flush panel">

            <b-list-group-item :active="currentRoute==='list-clients'"
                               :href="clientsRoutes['list-clients']"
                               class="item"
            >
                Liste des clients
            </b-list-group-item>
            <b-list-group-item :active="currentRoute==='list-clientGroups'"
                               :href="clientsRoutes['list-clientGroups']"
                               class="item"
            >
                Liste des groupes
            </b-list-group-item>

            <b-list-group-item
                :href="clientsRoutes['excel-clients']"
                class="item"
            >
                <i class="fa-fw fal fa-file-excel menu-icon"/>
                Export Excel
            </b-list-group-item>
            <!--TODO Temporarily disabled-->
            <b-list-group-item
                v-if="false"
                :active="currentRoute==='cador-clients'"
                :href="clientsRoutes['cador-clients']"
                class="item"
            >
                Mise à jour CADOR
            </b-list-group-item>
        </div>
        <data-filter/>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import DataFilter from '../../../common/components/DataFilterNew.vue'

export default {
    name: 'VerticalMenu',

    components: {
        DataFilter
    },

    props: {
        currentRoute: {
            required: true,
            type: String
        }
    },

    data() {
        return {
            clientsRoutes: []
        }
    },

    computed: {
        ...mapState({
            showVerticalMenu: (state) => state.reportingVM.showVerticalMenu,
            filters: (state) => state.reportingVM.filters,
            pageName: (state) => state.browsing.pageName
        })
    },

    created() {
        this.getClientsRoutes()
    },

    methods: {
        async getClientsRoutes() {
            try {
                const response = await axios.get('/clients/clientsRoutes')
                this.clientsRoutes = response.data
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        }
    }
}
</script>

<style scoped></style>
